module.exports = __webpack_public_path__ + "img/hays-logo.bed9ffe8.png";